'use client';

import ServiceLayout from '@/components/layout/service/ServiceLayout';

interface BoardLayoutProps {
    children: React.ReactNode;
}

export default function layout({ children }: BoardLayoutProps) {
    return <ServiceLayout showFooter={false}>{children}</ServiceLayout>;
}
